!(function () {
  "use strict";
  var e,
    t = {
      2970: function (e, t, r) {
        r.d(t, {
          s: function () {
            return d;
          },
        });
        var o = r(4559);
        const n = document.querySelector(".pdp-lightbox"),
          i = n.querySelector(".pdp-lightbox__close"),
          c = n.querySelectorAll("iframe, video"),
          d = (e) => {
            (0, o.jW)(!0),
              (0, o.My)(!0, l),
              n.classList.add("pdp-lightbox--open"),
              ((e) => {
                n.scrollTop =
                  n.querySelector('figure[data-id="' + e + '"').offsetTop +
                  parseInt(getComputedStyle(n).paddingTop);
              })(e);
          },
          l = () => {
            (0, o.jW)(!1),
              (0, o.My)(!1),
              n.classList.remove("pdp-lightbox--open"),
              Array.prototype.forEach.call(c, function (e) {
                if ("video" === e.tagName.toLowerCase()) e.pause();
                else {
                  var t = e.src;
                  e.src = t;
                }
              });
          };
        i.addEventListener("click", () => {
          l();
        }),
          n.querySelectorAll(".figure--image").forEach((e) => {
            e.addEventListener("click", l);
          }),
          window.addEventListener("load", function () {
            document.querySelector(".product-converter__gallery").swiper ||
              document
                .querySelectorAll(
                  ".product-converter__gallery figure:not(.figure--model)"
                )
                .forEach((e) => {
                  e.addEventListener("click", () => {
                    d(e.parentNode.getAttribute("data-id"));
                  });
                });
          });
      },
      8148: function (e, t, r) {
        var o = r(2479),
          n = r(2970);
        function i(e) {
          let t = e.closest(".product-converter__wrapper"),
            r = t.querySelectorAll(".swiper-slide"),
            i = t.querySelector(".swiper-pagination"),
            c = t.querySelector(".swiper-button-prev"),
            d = t.querySelector(".swiper-button-next");
          if (r.length > 1) {
            let t = new o.Ay(e, {
              preloadImages: !1,
              loop: !0,
              slidesPerView: 1,
              centeredSlides: !1,
              watchSlidesProgress: !0,
              a11y: { enabled: !1 },
              grabCursor: !0,
              spaceBetween: 16,
              pagination: { el: i, type: "fraction" },
              navigation: { nextEl: d, prevEl: c },
            });
            t.on("slideChange", function () {
              t.navigation.destroy(), t.navigation.init();
            }),
              t.on("click", function () {
                this.slides[this.clickedIndex].getAttribute("data-id") &&
                  (this.slides[this.clickedIndex].classList.contains("model") ||
                    this.slides[this.clickedIndex].classList.contains(
                      "video"
                    ) ||
                    (0, n.s)(
                      this.slides[this.clickedIndex].getAttribute("data-id")
                    ));
              }),
              e
                .closest(".product-converter__wrapper")
                .classList.add("slider-enabled");
          }
        }
        function c(e) {
          let t = window.matchMedia("(min-width: 0px) and (max-width: 767px)"),
            r = window.matchMedia("(min-width: 768px)");
          t.matches &&
            ("slider" == e.getAttribute("data-gallery-mobile")
              ? e.swiper || i(e)
              : e.swiper &&
                (e.swiper.destroy(!0, !0),
                e
                  .closest(".product-converter__wrapper")
                  .classList.remove("slider-enabled"))),
            r.matches &&
              ("slider" == e.getAttribute("data-gallery-desktop")
                ? e.swiper || i(e)
                : e.swiper &&
                  (e.swiper.destroy(!0, !0),
                  console.log("swiper should be destroyed"),
                  e
                    .closest(".product-converter__wrapper")
                    .classList.remove("slider-enabled")));
        }
        o.Ay.use([o.Vx, o.dK, o.Jq]),
          document
            .querySelectorAll(".product-converter__wrapper")
            .forEach((e) => {
              c(e.querySelector(".product-converter__gallery")),
                window.addEventListener("resize", function () {
                  c(e.querySelector(".product-converter__gallery"));
                });
            }),
          Shopify.designMode &&
            document.addEventListener("shopify:section:load", () => {
              document
                .querySelectorAll(".product-converter__wrapper")
                .forEach((e) => {
                  e.classList.contains("slider")
                    ? i(e.querySelector(".product-converter__gallery"))
                    : (c(e.querySelector(".product-converter__gallery")),
                      window.addEventListener("resize", function () {
                        c(e.querySelector(".product-converter__gallery"));
                      }));
                });
            });
      },
      4559: function (e, t, r) {
        r.d(t, {
          My: function () {
            return c;
          },
          jW: function () {
            return o;
          },
        });
        const o = function () {
          let e =
            arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          const t = window.innerWidth - document.body.offsetWidth,
            r = document.getElementById("nav-wrapper");
          e
            ? (document.body.classList.add("no-scroll"),
              (document.body.style.paddingRight = t + "px"),
              (r.style.paddingRight = t + "px"))
            : (document.body.classList.remove("no-scroll"),
              (document.body.style.paddingRight = "0px"),
              (r.style.paddingRight = "0px"));
        };
        let n = () => {};
        const i = (e) => {
            "Escape" === e.key &&
              (n(), window.removeEventListener("keydown", i));
          },
          c = function () {
            let e =
                arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
              t = arguments.length > 1 ? arguments[1] : void 0;
            t && (n = t),
              e && window.addEventListener("keydown", i),
              e || window.removeEventListener("keydown", i);
          };
        document.querySelectorAll(".local-scroll").forEach((e) => {
          e.addEventListener("click", (e) => {
            e.preventDefault(), e.stopPropagation();
            const t = e.target.getAttribute("href");
            ((e) => {
              Math.easeInOutQuad = function (e, t, r, o) {
                return (e /= o / 2) < 1
                  ? (r / 2) * e * e + t
                  : (-r / 2) * (--e * (e - 2) - 1) + t;
              };
              const t = document.getElementById("grid-archive-header"),
                r = document.getElementById("nav-wrapper");
              let o = 0,
                n = 0;
              t && (o = t.offsetHeight + 50), r && (n = r.offsetHeight + 50);
              const i = e.offsetTop - o - n,
                c = window.scrollY,
                d = i - c;
              let l = 0;
              const s = () => {
                l += 5;
                const e = Math.easeInOutQuad(l, c, d, 200);
                window.scrollTo(0, e), l < 200 && setTimeout(s, 5);
              };
              s();
            })(document.querySelector(t));
          });
        });
      },
    },
    r = {};
  function o(e) {
    var n = r[e];
    if (void 0 !== n) return n.exports;
    var i = (r[e] = { exports: {} });
    return t[e].call(i.exports, i, i.exports, o), i.exports;
  }
  (o.m = t),
    (e = []),
    (o.O = function (t, r, n, i) {
      if (!r) {
        var c = 1 / 0;
        for (a = 0; a < e.length; a++) {
          (r = e[a][0]), (n = e[a][1]), (i = e[a][2]);
          for (var d = !0, l = 0; l < r.length; l++)
            (!1 & i || c >= i) &&
            Object.keys(o.O).every(function (e) {
              return o.O[e](r[l]);
            })
              ? r.splice(l--, 1)
              : ((d = !1), i < c && (c = i));
          if (d) {
            e.splice(a--, 1);
            var s = n();
            void 0 !== s && (t = s);
          }
        }
        return t;
      }
      i = i || 0;
      for (var a = e.length; a > 0 && e[a - 1][2] > i; a--) e[a] = e[a - 1];
      e[a] = [r, n, i];
    }),
    (o.d = function (e, t) {
      for (var r in t)
        o.o(t, r) &&
          !o.o(e, r) &&
          Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    }),
    (o.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }),
    (o.j = 925),
    (function () {
      var e = { 925: 0, 457: 0 };
      o.O.j = function (t) {
        return 0 === e[t];
      };
      var t = function (t, r) {
          var n,
            i,
            c = r[0],
            d = r[1],
            l = r[2],
            s = 0;
          if (
            c.some(function (t) {
              return 0 !== e[t];
            })
          ) {
            for (n in d) o.o(d, n) && (o.m[n] = d[n]);
            if (l) var a = l(o);
          }
          for (t && t(r); s < c.length; s++)
            (i = c[s]), o.o(e, i) && e[i] && e[i][0](), (e[i] = 0);
          return o.O(a);
        },
        r = (self.webpackChunkworkflow = self.webpackChunkworkflow || []);
      r.forEach(t.bind(null, 0)), (r.push = t.bind(null, r.push.bind(r)));
    })();
  var n = o.O(void 0, [96], function () {
    return o(8148);
  });
  n = o.O(n);
})();
